/**
 * Copyright © 2026 Adnuntius AS.
 */
import {StaticProvider} from '@angular/core';

import {AdnFormStateService} from '../../../components/util/adn-form-state.service';

export function isCopyModalComponent(content: any): boolean {
  return typeof content?.name === 'string' && content.name.includes('CopyModal');
}

/**
 * Copy-modal search-select / money / labels call the page's AdnFormStateService
 * singleton and would mark the underlying edit form dirty. ngx-bootstrap
 * accepts extra providers for the modal injector, so copy modals get a no-op
 * instead of mutating page unsaved-changes state.
 */
export function copyModalPageFormProviders(): StaticProvider[] {
  return [{
    provide: AdnFormStateService,
    useValue: {
      setCurrentForm() {},
      markDirty() {},
      isDirty() {
        return false;
      },
      deregister() {}
    }
  }];
}
